import {MessageType} from './const';

export function responseTo(message: Message, payload?: MessagePayload): Message {
  return {
    name: message.name,
    type: MessageType.response,
    payload,
  };
}

export function infoMessage(name: MessageName, payload?: MessagePayload): Message {
  return {
    name,
    type: MessageType.info,
    payload,
  };
}

export function actionMessage(name: MessageName, payload?: MessagePayload): Message {
  return {
    name,
    type: MessageType.action,
    payload,
  };
}
